<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <client-form
          :data='data'
        />
      </div>
    </div>

    <div class="text-right">
      <btn-rounded
        label="SALVAR"
        event="saveClient"
      />
    </div>

  </div>
</template>
<script>
  import ClientForm from "components/UIComponents/Forms/ClientForm.vue";
  import {mapActions} from "vuex";

  export default {
    components: {
      ClientForm
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        data: {}
      };
    },
    created() {
      this.$on("saveClient", () => {
        let er = /^[a-zA-Z0-9][a-zA-Z0-9\._-]+@([a-zA-Z0-9\._-]+\.)[a-zA-Z-0-9]{2}/;

        if (er.exec(this.data.email)) {
          this.createUser(this.data)
            .then(res => {
              this.$notify({
                group: "foo",
                title: "Sucesso",
                text: res.msg,
                position: "top center",
                type: "success"
              });
              this.$router.push({
                name: "Usuários - Editar",
                params: {id: res}
              });
              this.data = {};
            })
            .catch(res => {
              this.$notify({
                group: "foo",
                title: res.msg, // "Criação.",
                text: res.info, //"Usuário criado com sucesso!",
                position: "top center",
                type: "error"
              });
              console.log(res);
            });
        } else {
          alert("Email inválido")
        }
      });
    },

    mounted() {
      this.data = !this.$route.params.user ? {} : this.$route.params.user;
    },
    methods: {
      ...mapActions(["createUser"]),

    }
  };
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Users/UserCreate.vue